<template>
  <div class="captcha-fake-wrapper pb-4">
    <v-checkbox
      v-model="model"
      :label="label"
      class="mb-0 pt-0"
      hide-details
    />
    <div class="pt-3">
      <img :src="captcha" class="captcha-icon ml-3" alt="captcha" />
    </div>
  </div>
</template>

<script>
import captcha from '@Assets/images/captcha.png';

export default {
  name: 'CaptchaFake',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: 'Não sou um robô' }
  },
  data: () => ({
    captcha
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.captcha-fake-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dcdcdc;
  padding: 12px 16px;
  border-radius: 4px;
  background-color: #f9f9f9;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  max-width: 350px;
  margin: 0 auto;

  .captcha-icon {
    height: 32px;
    margin-left: auto;
    padding-left: 12px;
  }
}
</style>
